import React from 'react';
import { useLanguage } from '../i18n/LanguageProvider';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="inline-flex items-center bg-white/70 backdrop-blur border border-slate/200 rounded-full p-1 text-sm">
      <button
        type="button"
        onClick={() => setLanguage('nl')}
        className={`px-3 py-1 rounded-full transition-colors ${language === 'nl' ? 'bg-sky text-navy' : 'text-slate hover:text-navy'}`}
        aria-pressed={language === 'nl'}
      >
        NL
      </button>
      <button
        type="button"
        onClick={() => setLanguage('en')}
        className={`px-3 py-1 rounded-full transition-colors ${language === 'en' ? 'bg-sky text-navy' : 'text-slate hover:text-navy'}`}
        aria-pressed={language === 'en'}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;


